import { Map, List, Record } from 'immutable'

import * as actions from './locationActions'

export const LocationSearchResultRecord = Record({
  id: null,
  name: null,
  slug: null,
}, 'LocationSearchResultRecord')

const initialState = Map({
  searchString: '',
  searchResults: List(),
  geoLocationLoading: false,
})

export default function locationReducer(state = initialState, action) {
  switch (action.type) {
    case actions.GET_GEOLOCATION:
      return state.set('geoLocationLoading', true)

    case actions.GET_GEOLOCATION_SUCCESS:
    case actions.GET_GEOLOCATION_FAILURE:
      return state.set('geoLocationLoading', false)

    case actions.FETCH_SEARCH_LOCATION:
      return state.set('searchString', action.searchString)

    case actions.CLEAR_LOCATION_SEARCH:
      return state
        .set('searchResults', List())
        .set('searchString', '')

    case actions.FETCH_SEARCH_LOCATION_ERROR_LENGTH:
    case actions.FETCH_SEARCH_LOCATION_FAILURE:
      return state.set('searchResults', List())

    case actions.FETCH_SEARCH_LOCATION_SUCCESS:
      return state.set('searchResults', List(action.response.data.map(result => LocationSearchResultRecord({
        id: result.id,
        name: result.name,
        slug: result.slug,
      }))))

    default:
      return state
  }
}
